const nextBtn = document.getElementsByClassName("slide_next");
const backBtn = document.getElementsByClassName("slide_previous");
const sliders = document.getElementsByClassName("product-cards-new-slider");

for (var i = 0; i < nextBtn.length; i++) {
  nextBtn[i].addEventListener("click", function (e) {
    e.target.parentNode.scrollLeft += 1050;
  });
  backBtn[i].addEventListener("click", function (e) {
    e.target.parentNode.scrollLeft -= 1050;
  });
}

const slider = document.querySelectorAll(".prod-slide");
let isDown = false;
let startX;
let scrollLeft;

for (let i = 0; i < slider.length; i++) {
  slider[i].addEventListener("mousedown", (e) => {
    isDown = true;
    slider[i].classList.add("active");
    startX = e.pageX - slider[i].offsetLeft;
    scrollLeft = slider[i].scrollLeft;
  });
  slider[i].addEventListener("mouseleave", () => {
    isDown = false;
    slider[i].classList.remove("active");
  });
  slider[i].addEventListener("mouseup", () => {
    isDown = false;
    slider[i].classList.remove("active");
  });
  slider[i].addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider[i].offsetLeft;
    const walk = (x - startX) * 3;
    slider[i].scrollLeft = scrollLeft - walk;
  });
}
